/** Created by azhou on 2019/3/22.*/
<template>
  <div>
    <public-title>集团管理
      <el-button slot="right" @click="addGroup" type="primary" class="ml-auto">添加集团单位</el-button>
    </public-title>
    <div class="bg-white load-area">
      <el-row>
        <el-col :span="12">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane v-for="(item,index) in $GVAR.StoreTypeGro" :label="item.name" :name="item.id" :key="index" />
          </el-tabs>
        </el-col>
        <el-col :span="12">
          <div class="text-right mt-2">
            <el-input placeholder="请输入集团名称" class="w-50" v-model="name" size="small">
              <el-button slot="append" icon="el-icon-search" size="small" @click="getDataLists(1)">搜索</el-button>
            </el-input>
          </div>
        </el-col>
      </el-row>
      <p v-if="AdminDataLists.total<=0" class="mt-3">当前没有数据</p>
      <div v-else>
        <ul class="list-head mt-3"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
        <ul class="list-item" v-for="item in AdminDataLists.lists" :key="item.id">
          <li class="w-50 list-item-col">{{item.group_name}}</li>
          <li class="w-50 list-item-col">
            {{item.truename}}
           <el-popover placement="right" trigger="hover">
                <div >
                  <span :class="[openid(item.uid,item.wechat_openid) ?'text-success':'text-danger']">{{openid(item.uid,item.wechat_openid) ?'已绑定':'未绑定'}} </span>
                </div>
                <i class="iconfont icon-weixin1 male" :class="[openid(item.uid,item.wechat_openid)  ? 'text-success' : 'text-muted']"  slot="reference"></i>
            </el-popover>
          </li>
          <li class="w-50 list-item-col">{{item.mobile}}</li>
          <li class="w-50 list-item-col" :class="$GFUN.userColor(item.type)">{{item.type | formatVar('StoreType')}}</li>
          <li class="w-50 list-item-col">
              <el-popover placement="right" trigger="hover">
                <div v-for="(v,ind) in item.store_list" :key="ind">
                  <i class=" text-link mr-1" :class="[v.verify==1?['el-icon-success','text-success']:['el-icon-error','text-danger']]" slot="reference"></i>
                   <!-- <span :class="[v.verify==1 ?'text-success':'text-danger']">{{v.verify==1?'已认证':'未认证'}} </span> -->
                  <!-- <i class="iconfont icon-weixin1 mr-1" :class="[v.verify==1 ? 'text-success' : 'text-muted']"></i> -->
                  <span class="mr-2">{{v.title}}</span>
                  <!-- <span class="mr-2">{{item.mobile}}</span> -->
                </div>
                <span slot="reference" class="text-link">{{item.store_list?item.store_list.length+'个':'无'}}</span>
              </el-popover>
            </li>
          <li class="w-50 list-item-col">{{item.num}}</li>
          <li class="w-50 list-item-col">{{item.reg_time | formatTimestamp(1)}}</li>
          <li class="w-50 list-item-col">
            <span class="text-link mr-1" @click="changeStatus({item,activeName})">[{{item.status ? '禁用' : '启用'}}]</span>
            <span :class="[item.status?'text-success':'text-danger']">{{item.status ? '启用中' : '禁用中'}}</span>
          </li>
          <li class="w-50 list-item-col-end flex-wrap">
            <span class="text-link ml-2" @click="relateStore(item,'add')">新增门店</span>
            <span class="text-link ml-2" @click="relateStore(item,'edit')">编辑门店</span>
          </li>
        </ul>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                       :total="AdminDataLists.total" :current-page="Number(queryCon.page)"
                       @current-change="$GFUN.pageChange"/>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions,mapState } from 'vuex'

  export default {
    name: 'GroupLists',
    computed: {
      ...mapState(['AdminDataLists']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
    },
    watch:{
      queryCon() { this.getDataLists(); },
    },
    mounted() { this.activeName = String(this.queryCon.tab); this.getDataLists(); },
    data() {
      return {
        titleArr:['集团名称','联系人名称','手机号','类型','门店个数','登陆次数','注册时间','状态','操作'],
        activeName: '3',
        name: ''
      }
    },
    methods:{
      ...mapActions(['getAdminDataLists','changeStatus']),
      //切换
      openid(uid,wechat_openid){
        return wechat_openid==''||uid==wechat_openid?false:true;
      },
      handleClick () {
        this.name='';
        this.$router.replace({name:this.$route.name,query: {...this.queryCon,page:1,tab: this.activeName}})
        // this.getDataLists()
      },
      //添加集团单位
      addGroup() {
        this.$router.push({name:'addGroup'})
      },
      //集团关联门店
      relateStore(item,status) {
        if (!this.$GFUN.powerIsInArray([94])) { this._alert('您没有相关权限！',null,'error'); return; }
        this.$router.push({name:'RelateStore',query:{type:item.type,id:item.group_id,status,name:item.group_name}})
      },
      //获取集团列表
      getDataLists(page) {
        let data={group_name: this.name,type: this.activeName,...this.queryCon};
        if(page==1)data.page=1;
        this.getAdminDataLists({
          type:'group',
          data:data
        });
      },
    }
  }
</script>
<style scoped>
  .male{
    margin-left: 4px;
    margin-top: 3px;
    font-size: 14px;
    cursor: pointer;
    display: inline-block;
  }
</style>
